export default __webpack_public_path__ + "static/media/bannersweb_hotsale_2_gmm_330x330.56c0677d.jpg";